// angular
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

// addon
import { mergeMap, switchMap, take } from 'rxjs/operators';
import { Observable, concat, zip } from 'rxjs';

// store
import { Store, select } from '@ngrx/store';
import * as fromStore from '@store/index';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private store: Store<fromStore.State>) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isCongifRequest = req.url.includes('config.json');
    const isTokenRequest = req.url.includes('token');
    const isRecoveryRequest = req.url.includes('recovery');

    if (isCongifRequest || isTokenRequest || isRecoveryRequest) {
      return next.handle(req);
    }

    return zip(
      this.store.pipe(select(fromStore.UserSelectors.getToken)),
      this.store.pipe(select(fromStore.UserSelectors.getRole))
    ).pipe(
      take(1),
      mergeMap(([token, role]) => {
        if (token) {
          if (req.url.includes('/api2/')) {
            req = req.clone({
              headers: req.headers.set('Authorization', 'Bearer ' + token)
            });
          } else {
            req = req.clone({
              headers: req.headers.set('Authorization', token)
            });
          }
        }

        if (role) {
          const url = req.url.split('/');

          url.splice(2, 0, role);

          req = req.clone({
            url: url.join('/')
          });
        }

        return next.handle(req);
      })
    );
  }
}
